import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  {
    pid: 4,
    lpSymbol: 'BUSDC-USDC LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      420042: '0xf986B6cc133329B3AD52FE876badFe75E73D13EB',
    },
    token: serializedTokens.BUSDC,
    quoteToken: serializedTokens.busd
  },
  {
    pid: 1,
    lpSymbol: 'MONEY-BESC LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      420042: '0xdF9672eDc87e198197dc3fA64997A99bab9ABa54',
    },
    token: serializedTokens.cake,
    quoteToken: serializedTokens.BESC,
  },
  {
    pid: 2,
    lpSymbol: 'USDC-VSG LP',
    lpAddresses: {
      97: '0xdbd23389df918176abf0e6f73cadefbbbac93d87',
      420042: '0xdbd23389df918176abf0e6f73cadefbbbac93d87',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 3,
    lpSymbol: 'BESC-VSG LP',
    lpAddresses: {
      97: '0x80216abe4ace3cd7cd923df826cf81da47e8e958',
      420042: '0x80216abe4ace3cd7cd923df826cf81da47e8e958',
    },
    token: serializedTokens.BESC,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 5,
    lpSymbol: 'BESC-BUSDC LP',
    lpAddresses: {
      97: '0x80216abe4ace3cd7cd923df826cf81da47e8e958',
      420042: '0xd321497f2f85a21fb94eefb21294e418fae421ab',
    },
    token: serializedTokens.BESC,
    quoteToken: serializedTokens.BUSDC,
  },

]

export default farms
